import React from 'react';
import style from './style.module.scss';

import { useFetch } from '@/hooks';
import Image from 'next/image';
import Link from 'next/link';
import { MiniTitle } from '@/ui/miniTitle/miniTitle';

interface PreviewPicture {
  // Здесь указываем свойства объекта previewPicture
  url: string;
  alt: string;
  data: any;
  // добавьте другие свойства в зависимости от структуры previewPicture
}



interface ParticCountriesItem {
  id: number;
  title: string;
  link: string;
  createdAt: string; // Можно использовать Date, если будете преобразовывать в даты
  updatedAt: string; // Аналогично
  publishedAt: string; // Аналогично
  previewPicture: PreviewPicture;
}

export const ParticCountries = async () => {
  const { data } = await useFetch(
    process.env.NEXT_PUBLIC_API_URL + '/strany-uchastnikis?populate=*',
  );

  if (!data) {
    return <p>Произошла ошибка...</p>;
  }
  return (
    <div className={style.countries}>
      <div className={style.top}>
        <MiniTitle text="Страны участники" />
      </div>
      <ul className={style.content}>
        {data?.map((elem: ParticCountriesItem) => {
          return (
            <li key={elem?.id} className={style.element}>
              <Link target='_blank' href={elem?.link}>
                <Image
                  src={process.env.NEXT_PUBLIC_APP_UPLOAD_URL + elem?.previewPicture?.url}
                  width={150}
                  height={100}
                  alt="poster"
                />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
